module.exports = __webpack_public_path__ + "static/media/alertIcon.c6699912.svg";